export const BASE_URL = 'https://dycapi.onrender.com/admin/';
// export const BASE_URL = 'https://dycapi.herokuapp.com/admin/';
